import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b3f279b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card p-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-blue fw-bolder" }, "Editar área")
], -1))
const _hoisted_3 = { class: "col-12 my-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-secondary",
  for: ""
}, "Ubicación", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Seleccione", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-12 my-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-secondary",
  for: ""
}, "Nombre del área", -1))
const _hoisted_9 = { class: "d-flex justify-content-center my-5" }
const _hoisted_10 = { class: "text-center d-block col-lg-3 col-sm-12" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn bg-blue rounded-pill text-white w-100"
  }, " Agregar ")
], -1))
const _hoisted_12 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      class: "row my-5 pb-5",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          class: "form-select bg-gray-input text-gray border-0 rounded-0",
          "aria-label": "Default select example",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ubicacionId) = $event)),
          name: "ubicacionId",
          id: "ubicacionId"
        }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ubicaciones, (ubicacion, i) => {
            return (_openBlock(), _createElementBlock("option", {
              key: i,
              value: ubicacion._id
            }, _toDisplayString(ubicacion.nombre), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.ubicacionId]
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control border-0 rounded-0 bg-gray-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nombre) = $event)),
            id: "nombre"
          }, null, 512), [
            [_vModelText, _ctx.nombre]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.back())),
              type: "button",
              class: "btn text-blue w-100"
            }, " Cancelar ")
          ])
        ])
      ])
    ], 32)
  ]))
}